import React, { useState, useEffect } from "react";
import axios from "axios";

const UserManagement = () => {
    const [users, setUsers] = useState([]);
    const [editingUserId, setEditingUserId] = useState(null);
    const [editedUser, setEditedUser] = useState({});

    useEffect(() => {
        axios
            .get("/api/admin/users")
            .then((res) => {
                const parsedUsers = res.data.users.map((u) => JSON.parse(u));
                setUsers(parsedUsers);
            })
            .catch((err) => console.error("Error loading users", err));
    }, []);

    const handleEditClick = (user) => {
        setEditingUserId(user._id["$oid"] || user._id);
        setEditedUser(user);
    };

    const handleDeleteUser = (userId) => {
        if (window.confirm("Are you sure you want to delete this user?")) {
            axios
                .delete(`/api/admin/users/${userId}`)
                .then(() => {
                    setUsers(users.filter((u) => (u._id["$oid"] || u._id) !== userId));
                })
                .catch((err) => console.error(err));
        }
    };

    const handleChange = (e) => {
        setEditedUser({ ...editedUser, [e.target.name]: e.target.value });
    };

    const handleSave = () => {
        axios
            .patch(`/api/admin/users/${editingUserId}`, editedUser)
            .then(() => {
                setUsers(users.map((u) =>
                    (u._id["$oid"] || u._id) === editingUserId ? editedUser : u
                ));
                setEditingUserId(null);
            })
            .catch((err) => console.error(err));
    };

    return (
        <div>
            <h2 className="text-2xl font-semibold text-gray-700 mb-4">User Management</h2>
            {users.length === 0 ? (
                <p className="text-gray-500">No users available.</p>
            ) : (
                <table className="min-w-full border border-gray-300">
                    <thead className="bg-gray-200">
                        <tr>
                            <th className="py-2 px-4 border">ID</th>
                            <th className="py-2 px-4 border">Username</th>
                            <th className="py-2 px-4 border">Email</th>
                            <th className="py-2 px-4 border">Roles</th>
                            <th className="py-2 px-4 border">Instructor</th>
                            <th className="py-2 px-4 border">Password</th>
                            <th className="py-2 px-4 border">Edit</th>
                            <th className="py-2 px-4 border">Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((user) => (
                            <tr key={user._id["$oid"] || user._id} className="hover:bg-gray-100">
                                <td className="py-2 px-4 border">{user._id["$oid"] || user._id}</td>
                                <td className="py-2 px-4 border">{user.username}</td>
                                <td className="py-2 px-4 border">{user.email}</td>
                                <td className="py-2 px-4 border">
                                    {user.roles && user.roles.join(", ")}
                                </td>
                                <td className="py-2 px-4 border">
                                    {editingUserId === (user._id["$oid"] || user._id) ? (
                                        <input
                                            type="text"
                                            name="instructor"
                                            value={editedUser.instructor || ""}
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded"
                                        />
                                    ) : (
                                        user.instructor || "-"
                                    )}
                                </td>
                                <td className="py-2 px-4 border">
                                    {editingUserId === (user._id["$oid"] || user._id) ? (
                                        <input
                                            type="password"
                                            name="password"
                                            placeholder="New password"
                                            onChange={handleChange}
                                            className="w-full border px-3 py-2 rounded"
                                        />
                                    ) : (
                                        "••••••"
                                    )}
                                </td>
                                <td className="py-2 px-4 border">
                                    {editingUserId === (user._id["$oid"] || user._id) ? (
                                        <button
                                            onClick={handleSave}
                                            className="px-3 py-1 bg-green-600 text-white rounded hover:bg-green-700"
                                        >
                                            Save
                                        </button>
                                    ) : (
                                        <button
                                            onClick={() => handleEditClick(user)}
                                            className="px-3 py-1 bg-indigo-600 text-white rounded hover:bg-indigo-700"
                                        >
                                            Edit
                                        </button>
                                    )}
                                </td>
                                <td className="py-2 px-4 border">
                                    <button
                                        onClick={() => handleDeleteUser(user._id["$oid"] || user._id)}
                                        className="px-3 py-1 bg-red-600 text-white rounded hover:bg-red-700"
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default UserManagement;